import React, { useEffect, useState } from "react";
import apiClient from "../axios/axiosInterceptor";
import '../modal.scss';
import BackgroundFileCreate from "./BackgroundFileCreate";
import BackgroundFileSearch from "./BackgroundFileSearch";
import BackgroundFileTable from "./BackgroundFileTable";
import {Slide, toast} from 'react-toastify'

function BackgroundFiles() {
    const [backgroundFiles, setBackgroundFiles] = useState([]);
    const [showCreateEditModal, setShowCreateEditModal] = useState(false);
    const [editingBackgroundFile, setEditingBackgroundFile] = useState(null);

    const baseUrl = `/backgroundFiles`;

    const fetchBackgroundFiles = async (params) => {
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setBackgroundFiles(response.data.list);
        } catch (error) {
            console.error('Error fetching background files:', error);
        }
    };

    useEffect(() => {
        fetchBackgroundFiles();
    }, []);

    const search = async (name) => {
        const newSearchParams = { name };
        await fetchBackgroundFiles(newSearchParams);
    };

    const handleCreate = () => {
        setEditingBackgroundFile(null);
        setShowCreateEditModal(true);
    };

    const handleEdit = (backgroundFile) => {
        setEditingBackgroundFile(backgroundFile);
        setShowCreateEditModal(true);
    };

    const handleDelete = async (id) => {
        const url = `${baseUrl}/${id}`;

        try {
            await apiClient.delete(url);
            await fetchBackgroundFiles();
        } catch (error) {
            console.error('Error deleting background file:', error);
        }
    };

    const handleCloseCreateEditModal = () => {
        setShowCreateEditModal(false);
    };

    const handleSubmitCreateEditModal = async (backgroundFileData) => {
        const url = editingBackgroundFile ? `${baseUrl}/${editingBackgroundFile.id}` : baseUrl;

        try {
            if (editingBackgroundFile) {
                await apiClient.patch(url, backgroundFileData);
                toast.success('Background file updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, backgroundFileData);
                toast.success('Background file created!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowCreateEditModal(false);
            await fetchBackgroundFiles();
        } catch (error) {
            console.error('Error saving background file:', error);
        }
    };

    return (
        <div className="mainBody">
            <BackgroundFileSearch onSearch={search} onCreate={handleCreate} />
            <BackgroundFileTable backgroundFiles={backgroundFiles} onEdit={handleEdit} onDelete={handleDelete} />

            {showCreateEditModal &&
                <BackgroundFileCreate backgroundFile={editingBackgroundFile} onClose={handleCloseCreateEditModal}
                                      onSubmit={handleSubmitCreateEditModal} />}
        </div>
    );
}

export default BackgroundFiles;
